<template>
  <div class="cart-page">
    <h1 class="cart-title">Panier</h1>

    <div v-if="cart.length > 0" class="cart-container">
      <!-- Liste des articles -->
      <div v-for="(item, index) in cart" :key="index" class="cart-item">
        <img :src="item.image" alt="Image produit" class="product-image" />
        <div class="item-details">
          <h3 class="item-name">{{ item.name }}</h3>
          <p class="item-detail">Prix unitaire :
            <span class="item-price">{{ item.price }} MAD</span>
          </p>

          <div class="quantity-controls">
            <button @click="decreaseQuantity(item)" class="btn quantity-btn">-</button>
            <span class="item-quantity">{{ item.quantity }}</span>
            <button @click="increaseQuantity(item)" class="btn quantity-btn">+</button>
          </div>

          <p class="item-detail">Total :
            <span class="item-total">{{ (item.price * item.quantity).toFixed(2) }} MAD</span>
          </p>
        </div>

        <button @click="removeFromCart(item.name)" class="btn remove-btn" title="Supprimer">
          <i class="fas fa-trash"></i>
        </button>
      </div>

      <!-- Prix total TTC -->
      <div class="total-section">
        <p class="total-price">Total TTC : <span>{{ totalPrice.toFixed(2) }} MAD</span></p>
      </div>

      <!-- Actions du panier -->
      <div class="cart-actions">
        <button @click="continueShopping" class="btn continue-btn">Continuer mes achats</button>

        <button @click="updateCart" class="btn update-btn" title="Mettre à jour">
          <i class="fas fa-sync-alt"></i>
        </button>

        <button @click="checkout" class="btn confirm-btn">Commander</button>
      </div>
    </div>

    <p v-else class="empty-cart">Votre panier est vide.</p>
  </div>
</template>

<script>
import { store } from "@/Store";

export default {
  name: "PanierI",
  computed: {
    cart() {
      return store.cart;
    },
    totalPrice() {
      return this.cart.reduce((total, item) => total + item.price * item.quantity, 0);
    },
  },
  methods: {
    removeFromCart(name) {
      store.removeFromCart(name);
      // Optionnel: resauvegarder le panier après suppression
      sessionStorage.setItem('cart', JSON.stringify(this.cart));
    },
    increaseQuantity(item) {
      item.quantity += 1;
      sessionStorage.setItem('cart', JSON.stringify(this.cart));
    },
    decreaseQuantity(item) {
      if (item.quantity > 1) {
        item.quantity -= 1;
        sessionStorage.setItem('cart', JSON.stringify(this.cart));
      }
    },
    updateCart() {
      // Si tu veux persister côté serveur, fais un appel ici.
      sessionStorage.setItem('cart', JSON.stringify(this.cart));
      alert("Panier mis à jour !");
    },
    continueShopping() {
      this.$router.push("/shop");
    },
    checkout() {
      // Sauvegarder le panier dans la session (utilisé par Shipping)
      sessionStorage.setItem('cart', JSON.stringify(this.cart));

      const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';

      if (isAuthenticated) {
        // Déjà connecté → aller directement à la page d'expédition
        this.$router.push("/shipping");
      } else {
        // Pas connecté → mémoriser la destination puis aller à /connexion
        sessionStorage.setItem('redirectAfterLogin', '/shipping');
        this.$router.push("/connexion");
      }
    }
  },
};
</script>

<style scoped>
/*STYLE CLAIR (par défaut) */
.cart-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  background-color: #f8f8f8;
  color: #222;
}
.cart-title {
  text-align: left;
  font-size: 2.5rem;
  color: #444;
  margin-bottom: 30px;
}

/* Conteneur du panier */
.cart-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Articles du panier */
.cart-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.product-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #ccc;
}
.item-details {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.item-name {
  font-size: 1.5rem;
  color: #141e28;
  margin-bottom: 10px;
}
.item-detail {
  font-size: 1rem;
  color: #555;
  margin: 5px 0;
}
.item-price,
.item-quantity,
.item-total {
  font-weight: bold;
}
.quantity-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
}
.quantity-btn {
  padding: 5px 10px;
  background-color: #2a9d8f;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.quantity-btn:hover {
  background-color: #23877b;
}

/* Section du prix total */
.total-section {
  text-align: right;
  margin-top: 20px;
  padding: 15px;
  border-top: 1px solid #ddd;
}
.total-price {
  font-size: 1.2rem;
  color: #333;
}
.total-price span {
  font-weight: bold;
  color: #2a9d8f;
}

/* Boutons */
.btn {
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}
.remove-btn {
  background-color: #e0240b;
  color: #fff;
}
.remove-btn:hover {
  background-color: #c82333;
}
.continue-btn {
  background-color: #2a9d8f;
  color: #fff;
}
.continue-btn:hover {
  background-color: #23877b;
}
.update-btn {
  background-color: #e8e5dc;
  color: #000;
}
.update-btn:hover {
  background-color: #d9d5c9;
}
.confirm-btn {
  background-color: #23877b;
  color: #fff;
}
.confirm-btn:hover {
  background-color: #2a9d8f;
}
.cart-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.empty-cart {
  text-align: center;
  font-size: 1.5rem;
  color: #777;
}

/* 📱 Responsive */
@media (max-width: 768px) {
  .cart-item {
    flex-direction: column;
    align-items: flex-start;
  }
  .product-image {
    width: 80px;
    height: 80px;
  }
  .btn {
    width: 100%;
    text-align: center;
  }
  .cart-actions {
    flex-direction: column;
    gap: 10px;
  }
}
@media (max-width: 480px) {
  .cart-title {
    font-size: 1.8rem;
  }
  .item-name {
    font-size: 1.2rem;
  }
  .item-detail {
    font-size: 0.9rem;
  }
  .product-image {
    width: 60px;
    height: 60px;
  }
}

/*MODE SOMBRE AUTOMATIQUE */
@media (prefers-color-scheme: dark) {
  .cart-page {
    background-color: #121212;
    color: #e0e0e0;
  }
  .cart-title {
    color: #f1f1f1;
  }
  .cart-item {
    background-color: #1e1e1e;
    border-color: #333;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
  }
  .product-image {
    border-color: #444;
  }
  .item-name {
    color: #fff;
  }
  .item-detail {
    color: #ccc;
  }
  .total-section {
    border-top-color: #333;
  }
  .total-price {
    color: #f1f1f1;
  }
  .update-btn {
    background-color: #333;
    color: #fff;
  }
  .update-btn:hover {
    background-color: #444;
  }
  .empty-cart {
    color: #aaa;
  }
}
</style>

